import axios from "axios";


export const roomTypePost = (body) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/RoomType`, body);
  };

  export const fetchRoomApiCall= () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/RoomType`);
  };